import { createFileRoute, Outlet } from '@tanstack/react-router';
import { Permission } from '../../features/common/permision';

export const Route = createFileRoute('/_creator-center/avatars')({
  pendingComponent: () => null,
  staticData: { permissions: [Permission.资产管理] },
  component: Assets,
});

function Assets() {
  return <Outlet />;
}
